// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
const identity = (x) => x;
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const keysOfSlow = identity;
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const keysOfFast = identity;
